import React from 'react'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar'
import ReportImg1 from '../../../../../assets/images/thankyou-1.png'
import ReportImg2 from '../../../../../assets/images/thankyou-2.png'
import ReportImg3 from '../../../../../assets/images/thankyou-1.png'
import Breadcrumbs from '../../../../../component/common/Breadcrumbs'
import { Link } from 'react-router-dom'
import Svg from '../../../../../component/common/Svg'

export default function ThankyouPage() {
    return (
        <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
            <SurveyListHeader />
            <div id="viewport" className="d-flex">
                <SurveyListSidebar />
                <div className="flex-grow-1">

                    <div className="survey-main-container">
                        <div className="survey-container">
                            <div className="reports-wrap">
                                <div className="page-heading">
                                    {/* breadcrumbs here */}
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to="/admin/survey/list">Survey</Link></li>
                                            <li className="breadcrumb-item active" aria-current="page"><strong>Thankyou Pages</strong></li>
                                        </ol>
                                    </nav>
                                    {/* breadcrumbs ends here */}
                                    <h2>Thankyou Pages</h2>
                                    {/* <a href="#" className='see-all'>Browse all</a> */}
                                </div>
                                <div className="report-list template-list">
                                    <div className="row">

                                        <div className="col-lg-3">
                                            <input type="radio" name="checkLanding" id="landing1" defaultChecked />
                                            <label htmlFor='landing1' className="report-inner">
                                                <div className="report-img">
                                                    <img src={ReportImg1} className="img-fluid" />
                                                </div>
                                                <div className="report-title d-flex align-items-center">
                                                    <div className="checkbox">
                                                        <div className="icon">
                                                            <Svg name='checkbox-check' />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">Thankyou Page 1</div>
                                                </div>
                                            </label>
                                        </div>
                                        <div className="col-lg-3">
                                            <input type="radio" name="checkLanding" id="landing2" />
                                            <label htmlFor='landing2' className="report-inner">
                                                <div className="report-img">
                                                    <img src={ReportImg2} className="img-fluid" />
                                                </div>
                                                <div className="report-title d-flex align-items-center">
                                                    <div className="checkbox">
                                                        <div className="icon">
                                                            <Svg name='checkbox-check' />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">Thankyou Page 2</div>
                                                </div>
                                            </label>
                                        </div>
                                        <div className="col-lg-3">
                                            <input type="radio" name="checkLanding" id="landing3" />
                                            <label htmlFor='landing3' className="report-inner">
                                                <div className="report-img">
                                                    <img src={ReportImg3} className="img-fluid" />
                                                </div>
                                                <div className="report-title d-flex align-items-center">
                                                    <div className="checkbox">
                                                        <div className="icon">
                                                            <Svg name='checkbox-check' />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">Thankyou Page 3</div>
                                                </div>
                                            </label>
                                        </div>
                                        <div className="col-lg-3">
                                            <input type="radio" name="checkLanding" id="landing4" />
                                            <label htmlFor='landing4' className="report-inner">
                                                <div className="report-img">
                                                    <img src={ReportImg2} className="img-fluid" />
                                                </div>
                                                <div className="report-title d-flex align-items-center">
                                                    <div className="checkbox">
                                                        <div className="icon">
                                                            <Svg name='checkbox-check' />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">Thankyou Page 4</div>
                                                </div>
                                            </label>
                                        </div>

                                    </div>
                                    {/* On Click of Load More 8 more grid items will load - infinite loading*/}
                                    <div className="button-wrap text-center mb-3 mb-md-4">
                                        <Link to="/admin/survey/template/thank-you/design" className='btn btn-bordered'>Continue</Link>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
